import React from 'react';
import { Spinner, Container } from 'react-bootstrap';

export default function LoadingFallback() {
  return (
    <Container className="mt-4 text-center">
      <Spinner animation="border" />
    </Container>
  );
}
